// Subtask rows on the master Tasks table.
//
// A row is a family: the table renders root tasks, and the count chip on a root
// ([data-subtask-toggle="<root pk>"]) fetches its subtask rows from
// [data-subtask-url] and inserts them underneath. Collapsing removes them again,
// so a page of roots with long subtask lists only ever holds the rows someone
// asked to see. This follows the Tasks list in Loop — count then caret, caret
// down while shut and up while open — including fetching on open.
//
// Presence is the state: rows under a root mean the family is open. A row swap
// (an inline edit, or a websocket refresh) re-renders the chip from a view that
// cannot know that, so the caret is restored from the rows after every swap.
(function () {
    function childRows(rootId) {
        return document.querySelectorAll('tr[data-work-task-parent="' + CSS.escape(rootId) + '"]');
    }

    function setCaret(toggle, open) {
        var caret = toggle.querySelector('i');
        if (caret) caret.className = 'fa-solid fa-chevron-' + (open ? 'up' : 'down');
    }

    async function expand(toggle, rootId) {
        var row = toggle.closest('tr');
        if (!row) return;
        toggle.disabled = true;
        setCaret(toggle, true);
        try {
            var response = await fetch(toggle.getAttribute('data-subtask-url'), {credentials: 'same-origin'});
            if (!response.ok) { setCaret(toggle, false); return; }
            var html = (await response.text()).trim();
            if (!row.isConnected) return;
            row.insertAdjacentHTML('afterend', html);
            if (window.htmx && row.parentElement) htmx.process(row.parentElement);
        } catch (error) {
            // A network interruption leaves the row shut; clicking again retries.
            setCaret(toggle, false);
            if (!(error instanceof TypeError)) throw error;
        } finally {
            toggle.disabled = false;
        }
    }

    document.addEventListener('click', function (e) {
        var toggle = e.target.closest('[data-subtask-toggle]');
        if (!toggle) return;
        e.preventDefault();
        var rootId = toggle.getAttribute('data-subtask-toggle');
        var rows = childRows(rootId);
        if (rows.length) {
            rows.forEach(function (row) { row.remove(); });
            setCaret(toggle, false);
            return;
        }
        expand(toggle, rootId);
    });

    function restoreCarets() {
        document.querySelectorAll('[data-subtask-toggle]').forEach(function (toggle) {
            setCaret(toggle, childRows(toggle.getAttribute('data-subtask-toggle')).length > 0);
        });
    }

    document.body.addEventListener('htmx:afterSwap', restoreCarets);
    document.body.addEventListener('htmx:afterSettle', restoreCarets);
})();

// A task's Subtasks card stays hidden until it has a subtask
// (`_item_sheet.html`, `item_detail.html`). The kebab's Add subtask
// ([data-work-reveal-subtasks="#<card id>"]) shows the card without its empty
// state, opens its add box and puts the cursor in it. Cancelling the add box
// while the card still has no subtask hides the card again; Cancel always
// clears the unsaved name.
document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-work-reveal-subtasks]');
    if (!trigger) return;
    var card = document.querySelector(trigger.getAttribute('data-work-reveal-subtasks'));
    if (!card) return;
    var wrap = card.closest('[hidden]');
    if (wrap) {
        wrap.hidden = false;
        wrap.setAttribute('data-work-subtasks-revealed', '');
    }
    var empty = card.querySelector('.empty-state');
    if (empty) empty.hidden = true;
    var reveal = card.querySelector('.collapse--open > [data-collapse-target]');
    if (reveal) reveal.click();
    setTimeout(function () {
        var input = card.querySelector('form input[type="text"], form input[name="name"]');
        if (input) input.focus();
        card.scrollIntoView({block: 'nearest', behavior: 'smooth'});
    }, 50);
});

document.addEventListener('click', function (e) {
    var cancel = e.target.closest && e.target.closest('[data-work-subtasks-revealed] form [data-collapse-target]');
    if (!cancel) return;
    var wrap = cancel.closest('[data-work-subtasks-revealed]');
    // Cancel drops what was typed, so the next Add subtask starts blank.
    cancel.closest('form').reset();
    if (wrap.querySelector('[id^="item-row-"]')) return;
    wrap.hidden = true;
    wrap.removeAttribute('data-work-subtasks-revealed');
});
